import { PlusIcon, XIcon } from "lucide-react";

import { Column } from "../Column";
import { Row } from "../Row";
import { Text } from "../Text";
import { Button } from "../ui/button";
import { stafferPets } from "../../lib/stafferPets";
import { cn } from "../../lib/utils";

export const StafferPetAccessorySlots = ({
  accessoryId,
  accessoryId2,
  selectedSlot,
  onSelect,
  onUnequip,
}: {
  accessoryId: string | null | undefined;
  accessoryId2: string | null | undefined;
  selectedSlot: 1 | 2;
  onSelect: (slot: 1 | 2) => void;
  onUnequip: (slot: 1 | 2) => void;
}) => {
  /* Render */
  const renderSlot = (slot: 1 | 2) => {
    const accessory = stafferPets.getAccessory(
      slot === 1 ? accessoryId : accessoryId2,
    );
    const isSelected = selectedSlot === slot;

    return (
      <Column key={slot} className="relative items-center gap-1">
        <Button
          type="button"
          variant="outlineDark"
          onClick={() => onSelect(slot)}
          className={cn(
            "h-16 w-16 rounded-none border-[3px] p-2 shadow-[3px_3px_0_#172033]",
            isSelected
              ? "border-slate-900 bg-orange-100"
              : "border-slate-400 bg-white hover:border-slate-900 hover:bg-orange-50",
          )}
        >
          {accessory ? (
            <img
              alt=""
              src={accessory.src}
              className="h-full w-full object-contain"
              style={{ imageRendering: "pixelated" }}
            />
          ) : (
            <PlusIcon className="h-5 w-5 text-slate-400" />
          )}
          <Text className="sr-only">{`Equip slot ${slot.toString()}: ${accessory?.label ?? "empty"}`}</Text>
        </Button>
        {accessory ? (
          <Button
            type="button"
            variant="outlineDark"
            onClick={() => onUnequip(slot)}
            className="absolute -right-2 -top-2 h-5 w-5 rounded-none border-2 border-slate-900 bg-white p-0 text-slate-700 hover:bg-orange-100"
          >
            <XIcon className="h-3 w-3" />
            <Text className="sr-only">{`Unequip ${accessory.label}`}</Text>
          </Button>
        ) : null}
        <Text
          className={cn(
            "font-mono text-[9px] font-black uppercase tracking-[0.1em]",
            isSelected ? "text-orange-700" : "text-slate-500",
          )}
        >
          {`Gear ${slot.toString()}`}
        </Text>
      </Column>
    );
  };

  const render = () => (
    <Row className="items-center gap-4 pb-1 pt-3">
      <Text className="font-mono text-[9px] font-black uppercase tracking-[0.12em] text-slate-500">
        Equipped
      </Text>
      {renderSlot(1)}
      {renderSlot(2)}
    </Row>
  );

  return render();
};
